import { render, staticRenderFns } from "./BatchOperationReview.vue?vue&type=template&id=8659824a&scoped=true&"
import script from "./BatchOperationReview.vue?vue&type=script&lang=js&"
export * from "./BatchOperationReview.vue?vue&type=script&lang=js&"
import style0 from "./BatchOperationReview.vue?vue&type=style&index=0&id=8659824a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8659824a",
  null
  
)

export default component.exports